import { produce } from 'immer';
import { StateCreatorWithDevtools } from '../store-utils';
import { Point, SelectedTicketInfo } from '../../logic/models';
import { Vector2 } from 'peet-math';
import { PlanSection } from 'mobile-venue-plan-js/lib/plan-section';

// INFO: New sale

export interface VenuePlanSearchStoreSlice {
    ticketSearchPoint: Vector2;
    setTicketSearchPoint: (ticketSearchPoint: Vector2) => void;
    
    /** Where the venue plan should focus next */
    newPlanFocusPoint: Point;

    /** When this changes, it means you should refresh your venue plan */
    planRefreshId: number;
    /** When this changes, it means you should refresh your venue plan */
    forcePlanRefresh: () => void;

    /** Calculate a focus plan according to some tickets */
    setPlanFocusPointFromTickets: (tickets: SelectedTicketInfo[]) => void;
}

export const VenuePlanSearchStoreSliceDef: StateCreatorWithDevtools<VenuePlanSearchStoreSlice, VenuePlanSearchStoreSlice> = (set, get) => {
    return {
        ticketSearchPoint: null,
        setTicketSearchPoint: (ticketSearchPoint: Vector2) => set({ ticketSearchPoint }, false, "ticketSearchPoint"),
        newPlanFocusPoint: null,
        planRefreshId: 0,

        forcePlanRefresh: () => set(produce(d => { d.planRefreshId++; }), false, "forcePlanRefresh"),

        setPlanFocusPointFromTickets: (tickets: SelectedTicketInfo[]) => {
            const nonGATickets = tickets ? tickets.filter(t => !t.ticket.IsGA) : null;
            let focusPoint: Point = null;

            if(nonGATickets.length > 0)
                focusPoint = nonGATickets[0].ticket.Position;

            set({ newPlanFocusPoint: focusPoint }, false, { type: "setPlanFocusPointFromTickets", tickets });
        },
    };
};

